import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { HiExternalLink } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';
import { AppWrap, MotionWrap } from '../../wrapper';
import blogs from '../../data/blogs.json';
import './Blogs.scss';

const Blogs = () => {
  const [topBlogs, setTopBlogs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    setTopBlogs(blogs.slice(0, 3));
  }, []);

  return (
    <>
      <h2 style={{ color: 'var(--primary-color)' }}>Latest Articles</h2>

      <div className="app__blogs-portfolio">
        {topBlogs.map((blog, index) => (
          <motion.a
            key={blog.title || index}
            href={blog.mediumUrl}
            target="_blank"
            rel="noreferrer"
            className="app__blog-item app__flex"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, delay: index * 0.1 }}
          >
            {/* Image */}
            <div className="app__blog-img app__flex">
              <img src={blog.coverUrl} alt={blog.title} loading="lazy" />
              <motion.div
                whileHover={{ opacity: [0, 1] }}
                transition={{ duration: 0.25, ease: 'easeInOut' }}
                className="app__blog-hover app__flex"
              >
                <div className="app__flex">
                  <HiExternalLink />
                </div>
              </motion.div>
            </div>

            {/* Content */}
            <div className="app__blog-content app__flex">
              <div className="app__blog-tag app__flex">
                <p className="p-text">{blog.tags[0]}</p>
              </div>
              <h4>{blog.title}</h4>
              <div className="blog-data">
                <p className="p-text">{blog.summary}</p>
                <div className="app__blog-bubbles">
                  {blog.tags.map((tag, i) => (
                    <span key={i} className="app__blog-bubble">{tag}</span>
                  ))}
                </div>
              </div>
            </div>
          </motion.a>
        ))}
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
        <button
          onClick={() => navigate('/all-blogs')}
          className="experience-btn"
        >
          View All Articles
        </button>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Blogs, 'app__blogs'),
  'blog',
  'app__whitebg',
);
